import { defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import { coverOptions } from "./index";
import UploadImage from "./upload-image.vue";
export default defineComponent({
    components: {
        UploadImage: UploadImage
    },
    props: {
        coverGroup: {
            type: definePropType(Array),
            default: function() {
                return coverOptions;
            }
        },
        // 支持的文件类型
        accepts: {
            type: definePropType(Array),
            default: function() {
                return [
                    "jpg",
                    "jpeg",
                    "png"
                ];
            }
        },
        // 限制上传文件大小 如: 2M
        maxSize: {
            type: Number,
            default: 2
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var cover_previews = ref({});
        var getCoverPreviews = function(val) {
            cover_previews.value = val;
            emit("cover_previews", cover_previews.value);
            console.log(cover_previews.value, "cover_previews.value");
        };
        return {
            getCoverPreviews: getCoverPreviews
        };
    }
});
